import { CompanyGroup } from './companyGroup/companyGroup.model';

export class Company {
    constructor(
        public id: number,
        public address1: string,
        public address2: string,
        public city: string,
        public countryCode: string,
        public zipCode: string,
        public name: string,
        public siret: string,
        public companyGroup: CompanyGroup,
        public company_id: number,
        public subCompanies: Company[],
        public deleted: boolean
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/company/company.model.ts